import oktaIcon from "asset/img/okta.svg";
import azureIcon from "asset/img/azure.svg";
import googleIcon from "asset/img/google.svg";
import pingIDIcon from "asset/img/ping_ID.svg";
import auth0Icon from "asset/img/auth_0.svg";

export const LOCAL_STORAGE = {
  USER_INFO: "userInfo",
  USER_NAME: "userName",
  USER_DATA: "userData",
  USER_TYPE: "userType",
  USER_ID: "userId",
  AUTH_KEY: "authKey",
  IS_FIRST_TIME: "isFirstTime",
  FORM_STATE: "formState",
  USER_TENANT_ID: "userTenantId",
  USER_API_KEY: "userApiKey",
};

export const SESSION_STORAGE = {
  SESSION_ID: "sessionId",
  REQUEST_ID: "requestId",
};

export const LANGUAGES = {
  EN: "en",
  FR: "fr",
};
export const LOCALE = {
  IN: "en-IN",
  US: "en-US",
};
export const DEFAULT_LOCALE_CONST = {
  LANG: "defaultLanguage",
  CURRENCY: "defaultCurrency",
  LOCALE: "defaultLocale",
};
export const ROUNDING_MODE = {
  ROUND: Math.round,
  FLOOR: Math.floor,
  CEIL: Math.ceil,
};

export const INPUT_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const INPUT_NUMBER_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const AUTOCOMPLETE_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const OTP_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const LABEL_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  RIGHT: "RIGHT",
};

export const DROPDOWN_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY",
  QUATERNARY: "QUATERNARY",
};

export const INPUT_ERROR_TYPE = {
  BORDER: "BORDER",
  DEFAULT: "DEFAULT",
};

export const LIMIT_TYPE = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
};

export const CHECKBOX_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const TOAST_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const BUTTON_STYLE_TYPE = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
};

export const COLOR_STYLE_TYPE = {
  RED: "RED",
  GRAY: "GRAY",
  PLUM: "PLUM",
};

export const LOADER_POSITION = {
  RIGHT: "right",
  LEFT: "left",
};
export const MIME_TYPE = {
  JSON: "application/json",
  PLAIN: "text/plain",
};

export const IS_ROUTE_GUARD = {
  Y: "Y",
  N: "N",
};

// ENVIRONMENT VARIABLE CONSTANTS
export const ENV_VAR = {
  VITE_BASE_API_URL: "VITE_BASE_API_URL",
  VITE_ENABLE_PWA_MODE: "VITE_ENABLE_PWA_MODE",
  VITE_LOCAL_DB_NAME: "VITE_LOCAL_DB_NAME",
  VITE_IS_ACL_ENABLED: "VITE_IS_ACL_ENABLED",
  VITE_IS_ROUTE_GUARD: "VITE_IS_ROUTE_GUARD",
  VITE_SHOW_LOGS: "VITE_SHOW_LOGS",
  VITE_GOOGL_MAP_KEY: "VITE_GOOGL_MAP_KEY",
  VITE_SHOULD_PERSIST: "VITE_SHOULD_PERSIST",
  VITE_PERSIST_STORAGE: "VITE_PERSIST_STORAGE",
  VITE_PERSIST_STORAGE_SECRET: "VITE_PERSIST_STORAGE_SECRET",
  BASE_DOMAIN: "BASE_DOMAIN",
  BE_BASE_URL: "BE_BASE_URL",
  VITE_AUTH: "VITE_AUTH",
  VITE_ENABLE_CONSTRUCT_URL: "VITE_ENABLE_CONSTRUCT_URL",
  VITE_APPDB_APP_CODE: "VITE_APPDB_APP_CODE",
};

export enum PERSIST_STORAGES {
  INDEX_DB = "INDEX_DB",
  LOCAL_STORAGE = "LOCAL_STORAGE",
  SESSION_STORAGE = "SESSION_STORAGE",
  CUSTOM = "CUSTOM",
}

export const SSO_PROVIDERS = {
  AUTH_0: "AUTH_0",
  OKTA: "OKTA",
  AZURE_AD: "AZURE_AD",
  PING_ID: "PING_ID",
  GOOGLE: "GOOGLE",
} as const;

export const SSO_PROVIDERS_CONFIG = {
  [SSO_PROVIDERS.AUTH_0]: {
    label: "Auth 0",
    icon: auth0Icon, // Replace with actual icon paths or component references
    value: "Auth 0",
    apiEndPoint: "auth0/login",
  },
  [SSO_PROVIDERS.OKTA]: {
    label: "Okta",
    icon: oktaIcon, // Replace with actual icon paths or component references
    value: "Okta",
    apiEndPoint: "okta/login",
  },
  [SSO_PROVIDERS.AZURE_AD]: {
    label: "Azure AD",
    icon: azureIcon, // Replace with actual icon paths or component references
    value: "AzureAD",
    apiEndPoint: "azure/login",
  },
  [SSO_PROVIDERS.PING_ID]: {
    label: "Ping Identity",
    icon: pingIDIcon, // Replace with actual icon paths or component references
    value: "Ping_ID",
    apiEndPoint: "oneid/login",
  },
  [SSO_PROVIDERS.GOOGLE]: {
    label: "Google",
    icon: googleIcon, // Replace with actual icon paths or component references
    value: "Google",
    apiEndPoint: "google/login",
  },
};

export const SOCIAL_PROVIDERS = {
  GOOGLE: "Google",
  FACEBOOK: "Facebook",
  GITHUB: "Github",
} as const;

export const SOCIAL_PROVIDERS_CONFIG = {
  [SOCIAL_PROVIDERS.GOOGLE]: {
    label: "Google",
    icon: "google-icon.svg",
    value: "Google",
    authUrl: "https://accounts.google.com/o/oauth2/v2/auth",
    scope: "email profile",
  },
  [SOCIAL_PROVIDERS.FACEBOOK]: {
    label: "Facebook",
    icon: "facebook-icon.svg",
    value: "Facebook",
    authUrl: "https://www.facebook.com/v11.0/dialog/oauth",
    scope: "email public_profile",
  },
  [SOCIAL_PROVIDERS.GITHUB]: {
    label: "GitHub",
    icon: "github-icon.svg",
    value: "Github",
    authUrl: "https://github.com/login/oauth/authorize",
    scope: "read:user user:email",
  },
};

export const SOCIAL_CLIENT_IDS = {
  [SOCIAL_PROVIDERS.GOOGLE]: "your-google-client-id",
  [SOCIAL_PROVIDERS.FACEBOOK]: "your-facebook-app-id",
  [SOCIAL_PROVIDERS.GITHUB]: "your-github-client-id",
};

export const URLS = {
  REGISTER: "https://www.viamagus.com/synthia/register",
  SUPPORT: "https://www.viamagus.com/synthia/support",
  SYNTHIA_AI_PRIVACY_POLICY: "https://viamagus.com/synthia-ai-privacy-cookies-policy",
};

export const AUTH_ACTION_TYPE = {
  RESET_PASSWORD: "RESET_PASSWORD",
  USER_SIGNUP: "USER_SIGNUP",
};

export const AUTH_CHANNEL = {
  EMAIL: "EMAIL",
};

export const PROSE_MIRROR_MODE = {
  EDIT: "edit",
  READONLY: "readonly",
  INPUT: "input",
} as const;

export const PROSE_MIRROR_TYPE = {
  DEFAULT: "default",
  EXCEL: "excel",
} as const;

export const PROSE_MIRROR_TEMPLATE = {
  EMAIL: "email",
  EXCEL: "excel",
} as const;

export enum BluejayNodeStatusStep {
  PREPROCESSING = "preprocessing",
  TRANSCRIBE_LOCAL_LANG = "transcribe_local_lang",
  TRANSLATE_ENGLISH_LANG = "translate_english_lang",
  ANALYZE_QC = "analyze_qc",
  GENERATE_RECOMMENDATION_ENGLISH_LANG = "generate_recommendation_english_lang",
  GENERATE_RECOMMENDATION_SUMMARY_ENGLISH_LANG = "pd_abstr_node_generate_recommendation_summary_english_lang",
  TRANSLATE_RECOMMENDATION_LOCAL_LANG = "translate_recommendation_local_lang",
  TRANSLATE_RECOMMENDATION_SUMMARY_LOCAL_LANG = "bj_node_translate_recommendation_summary_local_lang",
}

export const AppDBConfigUID = {
  BLUEJAY_RECO_SUMMARY_CONFIG_UID: "9236b07c-613b-4227-b85e-467026c12c16",
  BLUEJAY_RECO_CONFIG_UID: "bb90f9d1-f35b-4fa8-b206-70c50eca6591",
  BLUEJAY_ANALYSIS_CONFIG_UID: "be7834e8-85e0-41b1-baa0-6ccfbbf5c901",
  TARGET_LANGUAGE: "od-IN",
};

export const AppDBTableName = {
  STATUS: "status",
  FILE: "file",
  TRANSCRIPT: "transcript",
  ANALYSIS: "analysis",
  RECO: "reco",
  RECO_SUMMARY: "reco_summary",
};
